import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { Input, Button, Loader } from '@platzi/ui';
import { emailRegex } from '@platzi/commons';
import { saveEmail } from 'src/api';
import styles from './StartInPlatziForm.module.sass';

export const StartInPlatziForm = () => {
  const material = useSelector((state) => state.get('route').get('material_data'))?.toJS() || {};
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const { t } = useTranslation();

  const handleOnSubmit = (event) => {
    event.preventDefault();
    event.stopPropagation();

    if (isLoading) return;

    const value = event.target.email.value;

    if (value.trim() <= 0 || !emailRegex.test(value.toLowerCase().trim())) {
      return setError(t('route.startInPlatziForm.error'));
    } else {
      setIsLoading(true);

      const formData = new FormData();
      formData.append('email', value);
      formData.append('origin', 'routes');
      formData.append('full_path', window.location.href);

      const onboardingUrl = `/onboarding/?next=${material?.material_url}&email=${value}`;
      saveEmail(formData)
        .then(() => (window.location.href = onboardingUrl))
        .catch((err) => {
          throw new Error('::ERROR::ROUTES__START_IN_PLATZI_FORM', { cause: err });
        });
    }
  };

  return (
    <form className={styles.Form} onSubmit={handleOnSubmit}>
      <label htmlFor="email">{t('route.startInPlatziForm.label')}</label>
      <div className={styles.FormPosition}>
        <Input
          name="email"
          placeholder={t('route.startInPlatziForm.email')}
          behavior={error ? 'error' : 'default'}
          message={error}
          customClass={styles.Input}
        />
        <Button as="button" type="submit" color="platzi">
          {t('route.startInPlatziForm.startNow')}
          {isLoading && <Loader customStyle={styles.loader} />}
        </Button>
      </div>
      <p className={styles.Terms}>
        {t('route.startInPlatziForm.termsTextInitial')}{' '}
        <a target="blank" href="https://platzi.com/terminos/">
          {t('route.startInPlatziForm.termsTextTerms')}
        </a>{' '}
        {t('route.startInPlatziForm.and')}{' '}
        <a target="blank" href="https://platzi.com/privacidad/">
          {t('route.startInPlatziForm.termsTextPolitics')}
        </a>
      </p>
    </form>
  );
};
